import { handleActions } from 'redux-actions';
import {
  PRE_CHECK_USER_PENDING,
  PRE_CHECK_USER_DOESNT_EXISTS,
  PRE_CHECK_USER_NOT_ACTIVATED,
  PRE_CHECK_USER_SUCCESS,
  PRE_CHECK_USER_ERROR,
} from '../actions/auth';


const defaultState = { data: [], loading: false };

export default handleActions({  
  [PRE_CHECK_USER_PENDING]: (state, action) => {
    return {
      data: undefined,
      loading: true
    };
  },
  [PRE_CHECK_USER_DOESNT_EXISTS]: (state, action) => {
    return {
      data: {
        status: "doesnt_exists",        
      },
      loading: false,
      error: null
    };
  },
  [PRE_CHECK_USER_NOT_ACTIVATED]: (state, action) => {
    return {
      data: {
        status: "not_activated",
      },
      loading: false
    };
  },
  [PRE_CHECK_USER_SUCCESS]: (state, action) => {    
    return {
      data: action.payload,
      loading: false
    };
  },
  [PRE_CHECK_USER_ERROR]: (state, action) => {
    return {
      data: undefined,
      loading: false,
      error: action.payload,
      cancelTokenSource: null
    };
  },

}, defaultState)